<template>
  <div v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "tab",

  props: {
    name: { required: true },
    selected: { default: false }
  },

  data() {
    return {
      isActive: false
    };
  },

  computed: {
    href() {
      return "#" + this.name.toLowerCase().replace(/ /g, "-");
    }
  },

  mounted() {
    this.isActive = this.selected;
  }
};
</script>

<style lang="scss" scoped>
div {
  font-family: var(--roboto);
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.features li {
  background: url(https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg) no-repeat left center;
  padding-left: 40px;
}

.included li {
  background: url(https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg) no-repeat left center;
  padding-left: 20px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
